export const EXTERNAL_ASSESSMENT_NOTICE =
  "Registre aquí el resultado de una evaluación realizada fuera de Aurora. Aurora no proporciona el instrumento, no calcula la puntuación y no sustituye la interpretación profesional.";

export const CATEGORY_OPTIONS = [
  { value: "functional", label: "Funcional" },
  { value: "cognitive", label: "Cognitiva" },
  { value: "emotional", label: "Emocional" },
  { value: "nutritional", label: "Nutricional" },
  { value: "social", label: "Social" },
  { value: "falls", label: "Riesgo de caídas" },
  { value: "medication", label: "Medicamentos" },
  { value: "other", label: "Otra" },
];

export const RESULT_TYPE_OPTIONS = [
  { value: "numeric", label: "Numérico" },
  { value: "text", label: "Texto" },
  { value: "categorical", label: "Categórico" },
];

export const SOURCE_OPTIONS = [
  { value: "external_manual", label: "Registro manual externo" },
  { value: "paper", label: "Papel" },
  { value: "uploaded_report", label: "Informe recibido" },
  { value: "other", label: "Otra fuente" },
];

export function categoryLabel(value) {
  return CATEGORY_OPTIONS.find((o) => o.value === value)?.label || value || "—";
}

export function sourceLabel(value) {
  return SOURCE_OPTIONS.find((o) => o.value === value)?.label || value || "—";
}

export function statusLabel(value) {
  if (value === "voided") return "Anulada";
  if (value === "corrected") return "Corregida";
  return "Vigente";
}

export function formatAuditDate(value) {
  if (!value) return "—";
  return String(value).slice(0, 10);
}

export function formatResult(record) {
  if (!record) return "—";
  const unit = record.result_unit ? ` ${record.result_unit}` : "";
  if (record.result_value === null || record.result_value === undefined || record.result_value === "") {
    return "—";
  }
  return `${record.result_value}${unit}`;
}

export function emptyForm(patientId) {
  return {
    patient_id: patientId,
    category: "functional",
    assessment_name: "",
    assessment_date: "",
    result_type: "numeric",
    result_value: "",
    result_unit: "",
    physician_interpretation: "",
    source: "external_manual",
    source_note: "",
    notes: "",
  };
}

export function formFromRecord(record) {
  return {
    patient_id: record.patient_id,
    category: record.category || "other",
    assessment_name: record.assessment_name || "",
    assessment_date: String(record.assessment_date || "").slice(0, 10),
    result_type: record.result_type || "text",
    result_value: record.result_value ?? "",
    result_unit: record.result_unit || "",
    physician_interpretation: record.physician_interpretation || "",
    source: record.source || "external_manual",
    source_note: record.source_note || "",
    notes: record.notes || "",
  };
}

export function payloadFromForm(form) {
  const resultValue =
    form.result_type === "numeric" && form.result_value !== "" && form.result_value != null
      ? Number(form.result_value)
      : String(form.result_value || "").trim();
  return {
    patient_id: form.patient_id,
    category: form.category,
    assessment_name: String(form.assessment_name || "").trim(),
    assessment_date: form.assessment_date,
    result_type: form.result_type,
    result_value: resultValue,
    result_unit: form.result_unit?.trim() || undefined,
    physician_interpretation: form.physician_interpretation?.trim() || undefined,
    source: form.source,
    source_note: form.source_note?.trim() || undefined,
    notes: form.notes?.trim() || undefined,
  };
}
